<script setup lang="ts">
import { watchEffect } from "vue";
import {
  addNotification,
  notifications,
  removeNotification,
  replaceNotification,
} from "../states/notifications";
import { speakNotification } from "../states/currentSpeakers";
import RecordIconN from "./icons/notifications/RecordIconN.vue";
import HandUpIconN from "./icons/notifications/HandUpIconN.vue";

let lastNotify: string = "";
watchEffect(() => {
  if (speakNotification.value) {
    if (lastNotify) {
      replaceNotification(lastNotify, speakNotification.value);
    } else {
      lastNotify = addNotification(0, speakNotification.value);
    }
  } else {
    if (lastNotify) {
      removeNotification(lastNotify);
      lastNotify = "";
    }
  }
});
const components: {
  [key: string]: unknown;
} = {
  RecordIconN,
  HandUpIconN,
};
const calcgap = (not: (typeof notifications)[number]) => {
  if (not.button) return 16;
  else return 8;
};
</script>
<template>
  <Teleport to="body">
    <div class="notifications">
      <span
        v-for="not in notifications"
        :key="not.id"
        class="notify"
        :style="{
          gap: calcgap(not) + 'px',
        }"
      >
        <component
          :is="components[not.icon]"
          v-if="not.icon"
        />
        <span class="notify-text">{{ not.text }}</span>
        <button
          v-if="not.button"
          class="not-button"
          :class="{
            [not.button.style || '']: true,
          }"
          @click="not.button.action"
        >
          {{ not.button.text }}
        </button>
        <button
          v-if="not.canExit"
          class="close-btn"
          @click="not.clear()"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 4L16 16M4 16L16 4"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </button>
      </span>
    </div>
  </Teleport>
</template>
<style scoped>
.notifications {
  position: fixed;
  top: 12px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  left: 50%;
  transform: translate(-50%, 0);
}

.notify {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: rgba(41, 41, 41, 0.85);
  backdrop-filter: blur(2px);
  max-width: min(580px, 95vw);
  color: #ececec;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.not-button {
  background-color: rgba(73, 73, 73, 0.85);
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}

.not-button:hover {
  background-color: rgba(98, 98, 98, 1);
}

.not-button:active {
  background-color: rgba(41, 41, 41, 0.85);
}

.not-button:focus {
  outline: none;
}

.close-btn {
  background-color: transparent;
  display: flex;
  padding: 0;
  margin: 0;
  width: 20px;
  height: 20px;
  color: rgba(164, 164, 164, 1);
  border: none;
  outline: none;
  cursor: pointer;
}

.close-btn:hover {
  color: rgba(216, 216, 216, 1);
}

.close-btn:active {
  color: rgba(216, 216, 216, 1);
}

.notify-text {
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}

.blue-not-btn {
  background-color: var(--secondary-button-regular);
  color: #ffffff;
}

.blue-not-btn:hover {
  background-color: var(--secondary-button-hover);
}

.blue-not-btn:active {
  background-color: var(--secondary-button-active);
}

.white-not-btn {
  background-color: var(--white-btn-bg-regular);
  color: var(--white-btn-content-regular);
}

.white-not-btn:hover {
  background-color: var(--white-btn-bg-hover);
  color: var(--white-btn-content-hover);
}

.white-not-btn:active {
  background-color: var(--white-btn-bg-active);
  color: var(--white-btn-content-active);
}
</style>
